import { useMediaQuery } from '@material-ui/core'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
import { useAtom } from 'jotai'
import { mobileConnectAtom } from '../atoms/Wallet'

type ReturnType = (open: boolean) => void

export const useConnectModal = (): ReturnType => {
  const isMobile = useMediaQuery('(max-width: 43em)')
  const { visible, setVisible: setWalletModalVisible } = useWalletModal()
  const [, openMobileConnect] = useAtom(mobileConnectAtom)

  const setVisible = (open: boolean): void => {
    if (open === visible) {
      return
    }

    const window: any = globalThis.window

    if (isPhantomBrowser() || !isMobile) {
      setWalletModalVisible(open)
      return
    }

    if ('phantom' in window) {
      const provider = window.phantom?.solana

      if (provider?.isPhantom) {
        setWalletModalVisible(open)
        return
      }
    }

    openMobileConnect(true)
  }

  return setVisible
}

// function isMobile(): boolean {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
// }

function isPhantomBrowser(): boolean {
  return /Phantom/i.test(navigator.userAgent)
}
